import { MediaItem } from '../types';

/**
 * Determines if a media item is a photo, video, or unknown type.
 * This handles cases where Google Drive returns generic MIME types 
 * like 'application/vnd.google-apps.file' or 'application/octet-stream'
 * by checking the file extension as a fallback.
 */
export const getMediaType = (item: MediaItem): 'photo' | 'video' | 'unknown' => {
  // First, check if MIME type is explicitly image or video
  if (item.mimeType.startsWith('image/')) return 'photo';
  if (item.mimeType.startsWith('video/')) return 'video';
  
  // If MIME type is generic, check file extension
  const fileName = item.name.toLowerCase();
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.heic', '.heif', '.tiff', '.tif', '.ico'];
  const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', '.m4v', '.3gp', '.ogv', '.mpg', '.mpeg'];
  
  const extension = fileName.substring(fileName.lastIndexOf('.'));
  
  if (imageExtensions.includes(extension)) return 'photo';
  if (videoExtensions.includes(extension)) return 'video';
  
  return 'unknown';
};

/**
 * Helper functions to check if an item is a photo or video
 */
export const isPhoto = (item: MediaItem): boolean => getMediaType(item) === 'photo';
export const isVideo = (item: MediaItem): boolean => getMediaType(item) === 'video';
